import { observer } from 'mobx-react-lite';
import ViewTabPanel from '@components/view/view-tab-panel.tsx';
import ExperienceDetailsRanking from '@views/experience-details/view-components/experience-details-ranking.tsx';
import ExperienceDetailsRankingTable from '@views/experience-details/view-components/experience-details-ranking-table.tsx';
import experienceRankingStore from '@store/experience-ranking-store.ts';
import { useState } from 'react';
import { FullExperience } from '@/schemas/experience-schema.ts';

interface ExperienceDetailsRankingPanelProps {
	experience: FullExperience;
}

const ExperienceDetailsRankingPanel = observer(
	function ExperienceDetailsRankingPanel(
		props: ExperienceDetailsRankingPanelProps
	) {
		const [currentRankingsTab, setCurrentRankingsTab] = useState('');

		return (
			<ViewTabPanel
				tabs={[
					{
						key: 'ranking',
						title: 'Chart Rankings',
						children: (
							<ExperienceDetailsRanking
								placeId={props.experience.place_id}
							/>
						),
					},
					...(experienceRankingStore.experienceHaveRanking(
						props.experience.place_id
					)
						? [
								{
									key: 'milestones',
									title: 'Chart Ranking Milestones',
									children: (
										<ExperienceDetailsRankingTable
											placeId={props.experience.place_id}
											isHidden={
												currentRankingsTab !==
												'milestones'
											}
										/>
									),
								},
							]
						: []),
				]}
				onTabChange={setCurrentRankingsTab}
			/>
		);
	}
);

export default ExperienceDetailsRankingPanel;
